import React, { useState, useEffect } from 'react';
import './OlivIAApp.css';
import { api, guestToken } from '../lib/api';
import TopBar from './TopBar';
import Landing from './Landing';
import Gate from './Gate';
import ChatScreen from './ChatScreen';
import AdminLogin from './AdminLogin';
import Admin from './admin/Admin';

/* Racine Oliv'IA — reprise de la maquette validée, branchée sur l'API Rails.
   Toute la logique sensible (TOTP, coupons, clés IA, quotas) vit côté serveur. */
export default function OlivIAApp({ voice_enabled: voiceEnabled = false }) {
  const [screen, setScreen] = useState('landing');
  const [adminAuthed, setAdminAuthed] = useState(false);
  const [userAuthed, setUserAuthed] = useState(Boolean(guestToken.get()));
  const [simOffline, setSimOffline] = useState(false);

  useEffect(() => {
    // Sonde silencieuse : une session admin Devise est-elle déjà ouverte ?
    api.get('/api/admin/session')
      .then((data) => setAdminAuthed(Boolean(data?.authenticated)))
      .catch(() => {});
  }, []);

  const logoutGuest = () => {
    guestToken.clear();
    setUserAuthed(false);
  };

  const shared = {
    screen, setScreen,
    adminAuthed, setAdminAuthed,
    userAuthed, setUserAuthed,
    simOffline, setSimOffline,
    voiceEnabled,
    logoutGuest,
  };

  return (
    <div className="olivia-app">
      <TopBar {...shared} />
      {screen === 'landing' && <Landing {...shared} />}
      {screen === 'gate' && <Gate {...shared} />}
      {screen === 'chat' && <ChatScreen {...shared} />}
      {screen === 'adminLogin' && <AdminLogin {...shared} />}
      {screen === 'admin' && <Admin {...shared} />}
    </div>
  );
}
